module.exports = __webpack_public_path__ + "promo/app-store-badges/google-play-store-de-9988a41c6d8f1201f05eb6d3e2623dc9.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/google-play-store-de.svg
// module id = v6OI
// module chunks = 23